// src/pages/Home.js
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// Hero Section
const HeroSection = () => (
  <section
    className="optech-hero-section bg-cover"
    style={{ backgroundImage: "url(/assets/images/hero/bg1.png)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="optech-hero-content">
            <h5>Professional Translation Services!</h5>
            <h1>Delivering Translation solutions for your business</h1>
            <p>
              We are a reliable translation agency that provides precise and
              culturally adapted language solutions to help businesses.
            </p>
            <div className="optech-extra-mt">
              <div className="optech-btn-wrap">
                <NavLink
                  className="optech-default-btn"
                  data-text="Work With Us"
                  to="/contact-us"
                >
                  <span className="btn-wraper">Work With Us</span>
                </NavLink>
                <NavLink
                  className="optech-default-btn optech-white-btn"
                  data-text="View Services"
                  to="/about-us"
                >
                  <span className="btn-wraper">Know More</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5 offset-lg-1">
          <div className="optech-hero-thumb" data-aos="fade-up" data-aos-duration="700">
            <img src="/assets/images/hero/hero-thumb1.png" alt="hero visual" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Key Features Section
const KeyFeatures = () => (
  <section className="section extra-padding-tb">
    <div className="container">
      <div className="row">
        {[
          {
            icon: "icon1.svg",
            title: "Highly Expert Team",
            text:
              "Our industry specialist linguists, with deep expertise in regional dialects and technical translations, always ensure precise and culturally relevant communication.",
          },
          {
            icon: "icon2.svg",
            title: "24/7 Customer Service",
            text:
              "We offer round-the-clock support to assist you with project updates, urgent requests, or inquiries—anytime, anywhere, across all time zones.",
          },
          {
            icon: "icon3.svg",
            title: "Competitive Pricing",
            text:
              "We provide exceptional translation services at cost-effective rates, ensuring quality, accuracy, and value without compromising your budget.",
          },
        ].map(({ icon, title, text }) => (
          <div key={title} className="col-xl-4 col-md-6">
            <div className="optech-iconbox-wrap2">
              <div className="optech-iconbox-icon2">
                <img src={`/assets/images/iconbox/${icon}`} alt={title} />
              </div>
              <div className="optech-iconbox-data2">
                <h5>{title}</h5>
                <p>{text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Welcome Section
const WelcomeSection = () => (
  <div className="section large-padding-tb overflow-hidden">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="optech-thumb extra-mr">
            <img
              data-aos="fade-up"
              data-aos-duration="600"
              src="/assets/images/v1/thumb1.png"
              alt=""
            />
            <div
              className="optech-thumb-position"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <img src="/assets/images/v1/thumb2.png" alt="" />
            </div>
            <div className="optech-shape1">
              <img src="/assets/images/shape/shape1.svg" alt="" />
            </div>
            <div className="optech-shape2">
              <img src="/assets/images/shape/shape2.svg" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-6 d-flex align-items-end">
          <div className="optech-default-content ml40">
            <h2>Welcome To R.A. Inc.</h2>
            <h5>Empowering Global Communication Through Language</h5>
            <p>
              At R.A. Inc., we deliver professional translation and localization
              services that bridge the language and understanding gap. We offer
              precise, culturally relevant translations across various sectors,
              including legal, medical, technical, and business communication.
              Our team of linguists and industry-specific experts specializes in
              translation work for legal, technical, marketing, and medical
              purposes. Whether document translation, website localization,
              multimedia translation, etc., our work will always keep the
              original quality of your message intact so that it relates to
              native target audiences.
            </p>
            <div className="optech-extra-mt">
              <NavLink
                className="optech-default-btn"
                data-text="Know More"
                to="/about-us"
              >
                <span className="btn-wraper">Know More</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Services Overview
const ServicesOverview = () => (
  <div className="sectin bg-light1 optech-section-padding">
    <div className="container">
      <div className="optech-section-title center">
        <h2>Translation Solutions for Business Growth</h2>
      </div>
      <div className="optech-4column-slider2" data-aos="fade-up" data-aos-duration="800">
        {[
          {
            icon: "icon4.svg",
            title: "Translation Services",
            desc:
              "Culturally appropriate translations tailored to your industry and audience, delivered with linguistic precision and clarity.",
          },
          {
            icon: "icon5.svg",
            title: "Localization Services",
            desc:
              "Adapting your content to resonate with regional markets and local cultures, ensuring relevance across languages and geographies.",
          },
          {
            icon: "icon6.svg",
            title: "Voice Over Services",
            desc:
              "Professional multilingual voiceovers for commercials, e-learning, and media, recorded by native speakers, to enhance engagement.",
          },
          {
            icon: "icon7.svg",
            title: "Subtitle Services",
            desc:
              "We provide high-quality, synchronized subtitles for films, videos, and online content crafted to match tone, timing, and context.",
          },
          {
            icon: "icon8.svg",
            title: "Proofreading Services",
            desc:
              "Linguistic accuracy through expert editing and review, eliminating errors for polished, professional content.",
          },
          {
            icon: "icon6.svg",
            title: "Document Translations",
            desc:
              "Certified translation of official documents with precision and confidentiality, suitable for legal, academic, and business use.",
          },
        ].map(({ icon, title, desc }) => (
          <div key={title} className="optech-iconbox-wrap">
            <div className="optech-iconbox-icon">
              <img src={`/assets/images/iconbox/${icon}`} alt={title} />
            </div>
            <div className="optech-iconbox-data">
              <h5>{title}</h5>
              <p>{desc}</p>
              <NavLink className="optech-icon-btn" to="/languages">
                <i className="icon-show ri-arrow-right-line" />{" "}
                <span>Learn More</span>{" "}
                <i className="icon-hide ri-arrow-right-line" />
              </NavLink>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Industry-Specific Language Needs
// just above your Home component:
const LanguageNeedsSection = () => (
  <div className="section large-padding-tb4 overflow-hidden">
    <div className="container">
      <div className="row">
        {/* Right-side image */}
        <div className="col-lg-6 order-lg-2">
          <div className="optech-thumb extra-ml">
            <img
              data-aos="fade-up"
              data-aos-duration="600"
              src="/assets/images/v1/thumb3.png"
              alt=""
            />
            <div
              className="optech-thumb-position2"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <img src="/assets/images/v1/thumb4.png" alt="" />
            </div>
            <div className="optech-shape3">
              <img src="/assets/images/shape/shape3.svg" alt="" />
            </div>
            <div className="optech-shape4">
              <img src="/assets/images/shape/shape4.svg" alt="" />
            </div>
          </div>
        </div>

        {/* Left-side text */}
        <div className="col-lg-6 d-flex align-items-end">
          <div className="optech-default-content mr40">
            <h2>Your Industry-Specific Language Needs</h2>
            <p>
              We combine industry insight with cutting-edge tools to ensure
              consistency, accuracy, and contextual relevance across all
              content formats. We provide high-quality voice recordings in a
              wide range of languages, including Hindi, Bengali, Punjabi,
              Marathi, Gujarati, Tamil, Telugu, Malayalam, Nepali, Sinhala,
              Urdu, Pashto, Spanish, French, German, Italian, Portuguese,
              Russian, Polish, and Dutch—offered in neutral accents tailored
              to meet diverse regional preferences.
            </p>

            <div className="optech-extra-mt">
              <section id="first-sec"></section>

              {/* Progress bar 1 */}
              <div className="optech-progress-item">
                <div className="progress-bar" data-percentage="86%">
                  <div className="progress-title-holder">
                    <div className="progress-title">Industry-Specific Expertise</div>
                    <div className="progress-number-wrapper">
                      <div className="progress-number-mark">
                        <div className="percent"></div>
                      </div>
                    </div>
                  </div>
                  <div className="progress-content-outter">
                    <div className="progress-content"></div>
                  </div>
                </div>
              </div>

              {/* Progress bar 2 */}
              <div className="optech-progress-item">
                <div className="progress-bar" data-percentage="72%">
                  <div className="progress-title-holder">
                    <div className="progress-title">Native-Language Professionals</div>
                    <div className="progress-number-wrapper">
                      <div className="progress-number-mark">
                        <div className="percent"></div>
                      </div>
                    </div>
                  </div>
                  <div className="progress-content-outter">
                    <div className="progress-content"></div>
                  </div>
                </div>
              </div>

              {/* Progress bar 3 */}
              <div className="optech-progress-item">
                <div className="progress-bar" data-percentage="83%">
                  <div className="progress-title-holder">
                    <div className="progress-title">On-Time, Every Time</div>
                    <div className="progress-number-wrapper">
                      <div className="progress-number-mark">
                        <div className="percent"></div>
                      </div>
                    </div>
                  </div>
                  <div className="progress-content-outter">
                    <div className="progress-content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);


// Industries Served
const IndustriesSection = () => (
  <section className="section optech-section-padding bg-light1">
    <div className="container">
      <div className="optech-section-title center">
        <h2>Industries We Work With</h2>
      </div>
      <div className="row">
        <div
          className="col-xl-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <div className="optech-portfolio-wrap">
            <div className="optech-portfolio-thumb">
              <img src="/assets/images/p1/p1.png" alt="eLearning & Media" />
              <span className="p-btn-wraper">
                <i className="ri-arrow-right-up-line" />
              </span>
              <div className="optech-portfolio-data">
                <h4>eLearning & Media</h4>
                <p>
                  Curriculum localization, research publications, entertainment
                  subtitles
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-xl-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          <div className="optech-portfolio-wrap">
            <div className="optech-portfolio-thumb">
              <img
                src="/assets/images/p1/p2.png"
                alt="Technology Industry"
              />
              <span className="p-btn-wraper">
                <i className="ri-arrow-right-up-line" />
              </span>
              <div className="optech-portfolio-data">
                <h4>Technology Industry</h4>
                <p>
                  Software user interface localization, hardware documentation
                  updates
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-xl-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="900"
        >
          <div className="optech-portfolio-wrap">
            <div className="optech-portfolio-thumb">
              <img
                src="/assets/images/p1/telecome-img.png"
                alt="E-commerce & Retail Industry"
              />
              <span className="p-btn-wraper">
                <i className="ri-arrow-right-up-line" />
              </span>
              <div className="optech-portfolio-data">
                <h4>E-commerce & Retail Industry</h4>
                <p>
                  Product descriptions, localized sales funnels, global
                  marketing materials
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-xl-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <div className="optech-portfolio-wrap">
            <div className="optech-portfolio-thumb">
              <img src="/assets/images/p1/p4.png" alt="Banking & Finance" />
              <span className="p-btn-wraper">
                <i className="ri-arrow-right-up-line" />
              </span>
              <div className="optech-portfolio-data">
                <h4>Banking & Finance</h4>
                <p>Annual reports, loan agreements, and financial advisories</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-xl-8"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          <div className="optech-portfolio-wrap">
            <div className="optech-portfolio-thumb">
              <img src="/assets/images/p1/p5.png" alt="Marketing & Customer Support" />
              <span className="p-btn-wraper">
                <i className="ri-arrow-right-up-line" />
              </span>
              <div className="optech-portfolio-data">
                <h4>Marketing & Customer Support</h4>
                <p>Brand messaging, chatbot design, multilingual customer engagement</p>
              </div>
            </div>
          </div>
        </div>

        <div className="optech-extra-mt text-center">
          <NavLink
            className="optech-default-btn"
            data-text="View All Industries"
            to="/industry"
          >
            <span className="btn-wraper">View All Industries</span>
          </NavLink>
        </div>
      </div>
    </div>
  </section>
);

// Counter Section
const CounterSection = () => (
  <section className="section optech-section-padding-bottom">
    <div className="container">
      <div id="optech-counter" />
      <div
        className="optech-counter-wrap"
        style={{ backgroundImage: "url(/assets/images/v2/counter-bg.png)" }}
      >
        <div
          className="optech-counter-data"
          data-aos="fade-up"
          data-aos-duration="400"
        >
          <div className="optech-counter-icon">
            <img src="/assets/images/v2/icon1.svg" alt="Happy Clients icon" />
          </div>
          <div className="optech-counter-number">
            <span data-percentage="55" className="optech-counter" />
            +
          </div>
          <p>Happy Clients</p>
        </div>

        <div
          className="optech-counter-data"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="optech-counter-icon">
            <img src="/assets/images/v2/icon2.svg" alt="Projects icon" />
          </div>
          <div className="optech-counter-number">
            <span data-percentage="500" className="optech-counter" />
            +
          </div>
          <p>Projects</p>
        </div>

        <div
          className="optech-counter-data"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div className="optech-counter-icon">
            <img src="/assets/images/v2/icon3.svg" alt="Skilled Linguists icon" />
          </div>
          <div className="optech-counter-number">
            <span data-percentage="10" className="optech-counter" />
            +
          </div>
          <p>Skilled Linguists</p>
        </div>

        <div
          className="optech-counter-data"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="optech-counter-icon">
            <img src="/assets/images/v2/icon4.svg" alt="Year Experience icon" />
          </div>
          <div className="optech-counter-number">
            <span data-percentage="12" className="optech-counter" />
            +
          </div>
          <p>Year Experience</p>
        </div>
      </div>
    </div>
  </section>
);

// Testimonials Section
const Testimonials = () => (
  <section className="section optech-section-padding bg-light1">
    <div className="container">
      <div className="optech-section-title center">
        <h2>What Our Customers Say</h2>
      </div>
      <div
        className="optech-2column-slider"
        data-aos="fade-up"
        data-aos-duration="600"
      >
        {/* Testimonial 1 */}
        <div className="optech-t-box">
          <div className="optech-t-quote">
            <img src="/assets/images/v1/quote.svg" alt="quote" />
          </div>
          <div className="optech-t-data">
            <p>
              “ We had some fairly complex technical manuals and the R.A. Inc.
              team were really sharp on those. They were familiar with the
              industry terms and provided correct and easy to understand
              translations. Fantastic work! ”
            </p>
            <div className="optech-t-rating">
              <ul>
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <img
                      src="/assets/images/v1/rating.svg"
                      alt="star rating"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="optech-t-author">
              <h5>James Nolan</h5>
              <span>Product Lead</span>
            </div>
          </div>
        </div>

        {/* Testimonial 2 */}
        <div className="optech-t-box">
          <div className="optech-t-quote">
            <img src="/assets/images/v1/quote.svg" alt="quote" />
          </div>
          <div className="optech-t-data">
            <p>
              “ I wanted some urgent translations on professional documentations
              for my business and R.A. Inc. exceeded my expectations. The
              translations were precise, culturally appropriate, and within the
              deadline. Highly recommend! ”
            </p>
            <div className="optech-t-rating">
              <ul>
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <img
                      src="/assets/images/v1/rating.svg"
                      alt="star rating"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="optech-t-author">
              <h5>Alexander Cameron</h5>
              <span>Marketing Head</span>
            </div>
          </div>
        </div>

        {/* Testimonial 3 */}
        <div className="optech-t-box">
          <div className="optech-t-quote">
            <img src="/assets/images/v1/quote.svg" alt="quote" />
          </div>
          <div className="optech-t-data">
            <p>
              “ Working with R.A. Inc. was a seamless experience. Their
              attention to detail and commitment to quality helped us launch our
              product globally with confidence. I couldn’t be happier with their
              service! ”
            </p>
            <div className="optech-t-rating">
              <ul>
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <img
                      src="/assets/images/v1/rating.svg"
                      alt="star rating"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="optech-t-author">
              <h5>Brooklyn Simmons</h5>
              <span>Lead Developer</span>
            </div>
          </div>
        </div>

        {/* Testimonial 4 */}
        <div className="optech-t-box">
          <div className="optech-t-quote">
            <img src="/assets/images/v1/quote.svg" alt="quote" />
          </div>
          <div className="optech-t-data">
            <p>
              “ For my immigration process I needed certified translation and
              was impressed by the speed and professionalism of R.A. Inc. The
              documents were readily accepted. To say the least, the process
              went smoothly. ”
            </p>
            <div className="optech-t-rating">
              <ul>
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <img
                      src="/assets/images/v1/rating.svg"
                      alt="star rating"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="optech-t-author">
              <h5>David Mitchell</h5>
              <span>Operations Manager</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Call To Action
const CTASection = () => (
  <section
    className="section bg-cover optech-section-padding"
    style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}
  >
    <div className="container">
      <div className="optech-cta-wrap">
        <div className="optech-cta-content center">
          <h2>Let's Translate Your Vision Into Every Language</h2>
          <p>
            Whether you're expanding your business internationally or need
            multilingual content for local markets…
          </p>
          <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
            <NavLink
              className="optech-default-btn"
              data-text="Let’s Start a Project"
              to="/contact-us"
            >
              <span className="btn-wraper">Let’s Start a Project</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Home = () => {
  // init AOS on mount
  useEffect(() => {
    AOS.init({ once: true, duration: 700 });
  }, []);

  return (
    <>
      <HeroSection />
      <KeyFeatures />

      <div className="container">
        <div className="optech-divider" />
      </div>

      {/* now render every section in order */}
      <WelcomeSection />
      <ServicesOverview />
      <LanguageNeedsSection />
      <IndustriesSection />
      <CounterSection />
      <Testimonials />
      <CTASection />
    </>
  );
};

export default Home;